/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "DownloadCsvService";
const log: any = LoggerModule.getInstance();

export class DownloadCsvService {
  private static instance: DownloadCsvService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): DownloadCsvService {
    if (!DownloadCsvService.instance) {
      DownloadCsvService.instance = new DownloadCsvService(props);
    }
    return DownloadCsvService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getSectionOptInventoryReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.sectionOptInventoryReport(arg);
    return content;
  }

  public async getCostumeInventoryReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.costumeInventoryReport(arg);
    return content;
  }

  public async getDiscountReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getDiscountedReport(arg);
    return content;
  }

  public async getPaymentReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getPaymentReport(arg);
    return content;
  }

  public async getPrintSummaryReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getPrintSummaryReport(arg);
    return content;
  }

  public async getDeliveredReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getDeliveredReport(arg);
    return content;
  }

  public async getMasqReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getMasqReport(arg);
    return content;
  }
  public async getCouponReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getCouponReport(arg);
    return content;
  }

  public async getDiscountCouponReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getDiscountCouponReport(arg);
    return content;
  }

  public async getZeroPaymentReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getZeroPaymentReport(arg);
    return content;
  }

  public async getPartialPaymentReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getPartialPaymentReport(arg);
    return content;
  }

  public async getFullPaymentReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getFullPaymentReport(arg);
    return content;
  }

  public async getInactiveBoxesPaymentReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getInactiveBoxesReport(arg);
    return content;
  }

  public async getInactiveBoxesUpdatedPaymentReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getInactiveUpdatedBoxesReport(arg);
    return content;
  }

  public async getFeaturePaymentReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getFeatureReport(arg);
    return content;
  }

  public async getOpenRegReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getopenRegReport(arg);
    return content;
  }

  public async getCommitteeReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getCommitteeReport(arg);
    return content;
  }

  public async getSchedulesReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getSchedulesReport(arg);
    return content;
  }
}
